import { render, staticRenderFns } from "./FileUploadInput.vue?vue&type=template&id=2c304977"
import script from "./FileUploadInput.vue?vue&type=script&lang=ts"
export * from "./FileUploadInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports